import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {useLang} from '../components/LangProvider'

import EventList from './EventList';
import DocumentsList from "./DocumentsList";

function NavMenu({menuHandler, menuOpen}) {

    const [submenu, setSubmenu] = useState(0)
    const {lang} = useLang()

    useEffect(()=>{
        setSubmenu(0)
    },[menuOpen])

    return <nav id="nav" className={submenu > 0 ? " submenu-open" : ""}>
        <div className="nav-container">
            <div className="nav-menu">
                <h2>{lang["menu title"]}</h2>
                <Link onClick={() => menuHandler()} to="/">{lang["menu home"]}</Link>
                <Link className="is-submenu" onClick={() => setSubmenu(1)} to="#">{lang["menu events"]}</Link>
                <Link className="is-submenu" onClick={() => setSubmenu(2)} to="#">{lang["menu results"]}</Link>
                <Link className="is-submenu" onClick={() => setSubmenu(3)} to="#">{lang["menu documents"]}</Link>
                <Link onClick={() => menuHandler()} to="/auth">{lang["menu login"]}</Link>
                <button id="hide-nav" onClick={() => menuHandler()}>&#xf191;</button>
            </div>
            
            <div className="nav-submenu">
                <button id="back-to-nav" onClick={() => setSubmenu(0)}>&#xf048;</button>
                <div className={submenu == 1 ? "visible" : ""}>
                    <h2>{lang["menu events"]}</h2>
                    <EventList menuHandler={menuHandler}/>
                </div>
                <div className={submenu == 2 ? "visible" : ""}>
                    <h2>{lang["menu results"]}</h2>
                    <Link onClick={() => menuHandler()} to="/results">Single Race Results</Link>
                    <Link onClick={() => menuHandler()} to="/results">Single Race Results</Link>
                    <Link onClick={() => menuHandler()} to="/results">Single Race Results</Link>
                    <Link onClick={() => menuHandler()} to="/results">Single Race Results</Link>
                    <Link onClick={() => menuHandler()} to="/results">Single Race Results</Link>
                    <Link onClick={() => menuHandler()} to="/results">Single Race Results</Link>
                </div>
                <div className={submenu == 3 ? "visible" : ""}>
                    <h2>{lang["menu documents"]}</h2>
                    <DocumentsList />
                </div>
            </div>
        </div>
    </nav>
}

export default NavMenu